import { EquipmentStatus, type Equipment } from '../types';

/**
 * FE party rank-3 — AVAILABLE-prioritás rendezés.
 *
 * A wizard kereső a non-AVAILABLE gépeket is megjeleníti (disabled-render: a
 * pultos lássa hogy a gép létezik, csak bérelt), de az AVAILABLE-eket előre
 * rendezi, hogy a `slice(0, N)` a választható gépeket priorizálja. Stabil
 * (csoporton belül megőrzi az eredeti sorrendet), nem mutálja a bemenetet.
 */
export function prioritizeAvailable(equipments: Equipment[]): Equipment[] {
  const available: Equipment[] = [];
  const rest: Equipment[] = [];
  for (const eq of equipments) {
    (eq.status === EquipmentStatus.AVAILABLE ? available : rest).push(eq);
  }
  return [...available, ...rest];
}
